import React, { useState } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { toast } from 'sonner';

const ukFlagUrl = 'https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg';

const PreferredContactNumber = ({ phoneNumber, setPhoneNumber, setIsLoading }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempNumber, setTempNumber] = useState(phoneNumber || '');
  const axios = useAxiosPrivate();

  const handleSave = async (e) => {
    e.preventDefault();
    
    if (!tempNumber.trim()) {
      toast.error('Please enter a valid phone number.');
      return;
    }

    if (tempNumber.trim() === phoneNumber?.trim()) {
      toast.info('No changes to save.');
      setIsEditing(false);
      return;
    }

    try {
      setIsLoading?.(true);

      // await axios.post('/user/update-phone', {
      //   phoneNumber: tempNumber.trim(),
      // });

      setPhoneNumber(tempNumber.trim());
      // toast.success('Phone number updated successfully!');
      setIsEditing(false);
    } catch (error) {
      console.error(error);
      toast.error('Failed to update phone number. Please try again.');
    } finally {
      setIsLoading?.(false);
    }
  };

  const handleCancel = () => {
    setTempNumber(phoneNumber);
    setIsEditing(false);
  };

  return (
    <div className={isEditing ? '' : 'bg-white shadow-md rounded-lg p-4 border border-gray-200'}>
      {isEditing ? (
        <div className="w-full">
          <label className="text-lg font-semibold mb-2 block">Phone Number</label>

          <div
            style={{
              position: 'relative',
              width: '100%',
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor: '#fff',
              height: '56px',
              display: 'flex',
              alignItems: 'center',
              paddingRight: '16px',
              paddingLeft: '64px',
            }}
          >
            <img
              src={ukFlagUrl}
              alt="UK Flag"
              style={{
                position: 'absolute',
                left: '16px',
                width: '32px',
                height: '24px',
                borderRadius: '2px',
                objectFit: 'cover',
              }}
            />

            <input
              type="tel"
              value={tempNumber}
              onChange={(e) => setTempNumber(e.target.value)}
              name="phone"
              style={{
                flex: 1,
                height: '100%',
                border: 'none',
                outline: 'none',
                fontSize: '16px',
                fontWeight: 500,
                color: '#111',
                backgroundColor: 'transparent',
              }}
              placeholder="Enter phone number"
            />
          </div>

          <div className="flex justify-end gap-3 mt-3">
            <button
            type='button'
              onClick={handleSave}
              className="w-24 h-12 px-6 py-3 bg-[#7B5FA6] rounded-md text-sm font-bold hover:bg-[#DDCCDF] text-white flex justify-center items-center"
            >
              Save
            </button>
            <button
            type='button'
              onClick={handleCancel}
              className="min-h-[48px] px-4 py-2 bg-white text-black rounded hover:bg-gray-200"
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div className="flex justify-between items-start">
          <div className="space-y-1">
            <h2 className="text-lg font-semibold mb-1">Preferred contact number</h2>
            <p className="text-sm text-gray-900">{phoneNumber || 'No number entered'}</p>
          </div>
          <button
            type="button"
            onClick={() => {
              setTempNumber(phoneNumber);
              setIsEditing(true);
            }}
            className="text-blue-600 hover:underline text-sm font-medium"
          >
            Edit
          </button>
        </div>
      )}
    </div>
  );
};

export default PreferredContactNumber;
